export default __webpack_public_path__ + "static/media/flag_pt_PT.16673426.png";